import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    vehicleStatus: {
      borderRadius: 2,
      color: '#fff',
      fontSize: '12px',
      fontWeight: 500,
      padding: '6px 16px',
      position: 'relative',
    },
    inshop: {
      backgroundColor: theme.palette.grey[500],
    },
    active: {
      backgroundColor: theme.palette.status.active,
    },
    retired: {
      backgroundColor: theme.palette.grey[500],
    },
    inactive: {
      backgroundColor: theme.palette.grey[500],
    },
    vehicleLink: {
      fontSize: '12px',
      fontWeight: 500,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
        fontWeight: 500,
      },
    },

    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.text.primary,
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    vehicleImg: {
      maxHeight: 150,
      maxWidth: '100%',
    },

    vehicleList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    vehicleListItem: {
      width: '100%',
      padding: '0 4px 8px 0',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },

    vehicleDivider: {
      margin: '7px -25px 0',
    },
  };
});

const listStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      fontSize: 13,
      fontWeight: 500,
      color: '#4D4F5C',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      wordBreak: 'break-word',
      maxWidth: '70%',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      fontSize: '13px',
      fontWeight: 'bold',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, listStyles, listTextStyles, customCardStyles, collapseCardStyles };
